import { Injectable } from '@angular/core';
import { HttpClient } from '../_services/global-http.service';
import {Observable} from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class RegistrationSearchService {

  public isSearching = false;
  public lastResults = [];

  constructor (private http: HttpClient) {}

  findVehicles(registration) {
    this.isSearching = true;
    return new Observable((observer) => {
      const extAppKey: string = environment.externalAppKeys.dpd;
      this.http.get('/api/help/vehicle_search/?pageSize=3&page=1&ordering=-registration&search=' + registration, null, false, {'Authorization': extAppKey})
      .subscribe((data) => {
        this.isSearching = false;
        observer.next(data.results);
      });
    });
  }

}


// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/registration-search.service.ts